/**
 * @description Default environment variables, which are used if no environment variables are set.
 *
 */
export const DEFAULT_ENVIRONMENT = {
  isActiveBRSwipeWidget: false,
  isActiveBRSmallWidget: false,
  bRSwipeWidgetApiKey: '',
  bRSmallWidgetApiKey: '',
  isJacktimeActive: false,
  isQuickAmount: false,
  currencySymbol: '€',
  teamImageAssetsUrl: '',
  isOddFav: false,
  isOddFormatTypeSelect: false,
  isBetSettings: false,
  getTopBets: false,
  isPromotion: false,
  birthdateBonusModal: false,
  isServe: false,
  liveChatUrl: '',
  appStorelink: '',
  androidPlayLink: '',
  isCasino: false,
  isSeon: false,
  isSwipeWidgetShow: true,
  isWildCard: false,
  siteUrl: '',
  cmsRegisterDefaultAssetUrl: '',
  cmsMobilRegisterDefaultAssetUrl: '',
  healthUrl_2: '',
};
